import store from '@/store';

// Each person's menu position ("vertical" = side menu, "horizontal" = top menu), saved in this browser per user.
// Signed-out visitors and anyone who hasn't chosen get the side menu.

const KEY_PREFIX = 'menuLayout:';
const LAYOUTS = ['vertical', 'horizontal'];

function currentUserId() {
  try {
    const user = JSON.parse(localStorage.getItem('userData'));
    return user && user.id ? user.id : null;
  } catch (e) {
    return null;
  }
}

export function savedMenuLayout() {
  const userId = currentUserId();
  if (!userId) return 'vertical';
  try {
    const value = localStorage.getItem(KEY_PREFIX + userId);
    return LAYOUTS.includes(value) ? value : 'vertical';
  } catch (e) {
    return 'vertical';
  }
}

// Puts the signed-in person's saved choice into effect (App.vue calls this on load and after each navigation,
// which covers signing in and out).
export function applyMenuLayout() {
  const layout = savedMenuLayout();
  if (store.state.appConfig.layout.type !== layout) {
    store.commit('appConfig/UPDATE_LAYOUT_TYPE', layout);
  }
}

export function setMenuLayout(layout) {
  if (!LAYOUTS.includes(layout)) return;
  const userId = currentUserId();
  if (userId) {
    try {
      localStorage.setItem(KEY_PREFIX + userId, layout);
    } catch (e) {
      // Storage can be unavailable; the change still applies for this visit.
    }
  }
  store.commit('appConfig/UPDATE_LAYOUT_TYPE', layout);
}
